/**
 * 즐겨쓰는 기능 모음
 * 
 * 개발자 : T/F팀
 * 개발년월 : 2022.11.
 */
export class FxUtil {

	static isEmpty(s)
	{
		return s === undefined || s === null;
	}


	static isSameObject(o1, o2) {
		try {
			const keys1 = Object.keys(o1);
			const keys2 = Object.keys(o2);

			if (keys1.length === 0 && keys2.length === 0) {
				return true;
			}

			if (keys1.length !== keys2.length) {
				return false;
			}

			for (let key of keys1) {
				if (o1[key] !== o2[key]) {
					return false;
				}
			}

			return true;
		} catch (error) {
			return false;
		}
	}	
}
